import { QueryCache, QueryClient } from '@tanstack/react-query';

import { ApiError } from './client';

/**
 * Builds the query client with the retry policy the API deserves: no retries on a refusal, two
 * on network or server errors. Platform-neutral: the Expo app builds its client here too and
 * adds persistence on top.
 *
 * @returns The client.
 */
export const createQueryClient = (): QueryClient =>
  new QueryClient({
    queryCache: new QueryCache(),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (count, error) =>
          error instanceof ApiError &&
          ((count < 2 && (error.code === 'NETWORK' || error.code === 'INTERNAL')) ||
            // The dev cluster resumes from auto-pause in about half a minute (ticket #73).
            (count < 8 && error.code === 'UNAVAILABLE')),
        retryDelay: (count, error) =>
          error instanceof ApiError && error.code === 'UNAVAILABLE'
            ? 4000
            : Math.min(1000 * 2 ** count, 30_000),
      },
    },
  });
